export const ORGANISATION_DEFAULTS = {
    orgName: "Design Center of the Philippines",
    appName: "Human Resource Management System",
    tagline: "We effect positive change through design."
};
